/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import { absoluteUrl } from "../../lib/urls"
function Seo({ description, lang, meta, title, image, imageAlt, jsonLd }) {
  const { pathname } = useLocation()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  // const defaultTitle = site.siteMetadata?.title
  const defaultTitle = '';

  var urlPath = absoluteUrl(site.siteMetadata.siteUrl, pathname)

  // Absolute URL for the social share image (og:image / twitter:image).
  // absoluteUrl rather than concatenation: siteUrl carries no trailing slash,
  // so a relative path without a leading one would otherwise glue straight onto
  // the host as "https://findmymethod.orgsocial.png".
  const metaImage = image
    ? image.startsWith("http")
      ? image
      : absoluteUrl(site.siteMetadata.siteUrl, image)
    : null

  const imageMeta = metaImage
    ? [
        { property: `og:image`, content: metaImage },
        { name: `twitter:image`, content: metaImage },
        ...(imageAlt
          ? [
              { property: `og:image:alt`, content: imageAlt },
              { name: `twitter:image:alt`, content: imageAlt },
            ]
          : []),
      ]
    : []

  const jsonLdBlocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang,
        }}
        title={title}
        titleTemplate={defaultTitle ? `%s - ${defaultTitle}` : null}
        meta={[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            property: `og:url`,
            content: urlPath,
          },
          {
            name: `twitter:card`,
            content: metaImage ? `summary_large_image` : `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata?.author || `Women First Digital`,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ]
          .concat(imageMeta)
          .concat(meta)}
      >
        {jsonLdBlocks.map((block, i) => (
          <script type="application/ld+json" key={i}>
            {JSON.stringify(block)}
          </script>
        ))}
      </Helmet>
    </>
  )

}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  image: null,
  imageAlt: null,
  jsonLd: null,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  languages: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  jsonLd: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

export default Seo
